import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';

class AnalyticInventoryRegionalCoverageService extends EntityApiService<any> {
  getLastUpdated = () =>
    this.handleResponse(ApiClientService.get(this.getPath('/last-update')));

  getOverview = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/overview'), params, config));

  getGapMatrix = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/gap-matrix'), params, config));

  getGaps = (origin: string, destination: string, params?: any, config?: RequestConfig) =>
    this.handleResponse(
      ApiClientService.post(this.getPath(`/gaps/${origin}/${destination}`), params, config),
    );

  getCritical = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/critical'), params, config));

  getCategories = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/categories'), params, config));

  getSuppliers = (params?: any, config?: RequestConfig) =>
    this.handleResponse(ApiClientService.post(this.getPath('/suppliers'), params, config));
}

export default new AnalyticInventoryRegionalCoverageService(
  '/ms-analytics/api/v1/regional-coverage-analytic',
);
